import type { Streamfield } from '@/types';
import Streamfields from '@streamfields/Streamfields';
import { BasePageProps, basePageWrap } from '@views/BasePage';
import React from 'react';

type Props = { content: Streamfield[] } & BasePageProps;

function FlexPage(props: Props) {
  const { title, content } = props;
  return (
    <div className='flex-page'>
      <h1 className='page-title container'>{title}</h1>
      {content ? <Streamfields fields={content} /> : null}
    </div>
  );
}

export default basePageWrap<Props>(FlexPage);
